import {Component, Input} from '@angular/core';

@Component({
  selector: 'mc-alert-action',
  templateUrl: './alert-action.component.html',
  styleUrls: ['./alert-action.component.scss'],
})
export class AlertActionComponent {
  @Input() href: string = '';
}
